import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var AutomatedWorkflowsSvg = function AutomatedWorkflowsSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.547 2.249c-.686 0-1.345.27-1.83.75a2.56 2.56 0 0 0-.65 1.08H2v1.463h3.067c.121.404.343.776.65 1.08.485.48 1.144.75 1.83.75s1.346-.27 1.831-.75c.307-.304.529-.676.65-1.08h10.186v5.396h-5.1a2.56 2.56 0 0 0-.65-1.079 2.6 2.6 0 0 0-1.831-.75c-.687 0-1.345.27-1.83.75a2.56 2.56 0 0 0-.651 1.08H2.185v8.323h2.882c.121.404.343.776.65 1.08.485.48 1.144.75 1.83.75s1.346-.27 1.831-.75c.307-.304.529-.676.65-1.08h9.14l-1.973 1.952 1.046 1.035L22 18.53l-3.76-3.719-1.045 1.035 1.973 1.953h-9.14a2.56 2.56 0 0 0-.65-1.08 2.6 2.6 0 0 0-1.83-.75c-.687 0-1.346.27-1.831.75a2.56 2.56 0 0 0-.65 1.08H3.664v-5.397h6.488c.122.404.343.776.65 1.08.486.48 1.144.75 1.83.75s1.346-.27 1.831-.75c.307-.304.529-.676.65-1.08h6.58V4.078H10.029A2.56 2.56 0 0 0 9.378 3a2.6 2.6 0 0 0-1.83-.75"
  }));
};
export var AutomatedWorkflows = function AutomatedWorkflows(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: AutomatedWorkflowsSvg
  }));
};